import gql from 'graphql-tag'

const clienti = gql`
  query clienti (
    $limit: Int!
    $offset: Int
    $where: ClientiFilterInput
    $orderBy: [ClientiOrderBy]
  ) {
    clienti (
      limit: $limit
      offset: $offset
      where: $where
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        agenteId
        agente {
          id
          nome
        }
        nome
        email
        email2
        telefono
        telefono2
        comune
        dataCreazione
        daRicontattare
        dataUltimaRichiesta
        dataUltimoContatto
        voto
        tipo
        nuovoClienteFlag
        telNonRisposte
        interessi {
          nome
        }
      }
    }
  }
`

export default clienti



// WEBPACK FOOTER //
// ./src/graphql/queries/clienti.js